import { render } from "./usingLocales.vue?vue&type=template&id=7922f7bc"
import script from "./usingLocales.vue?vue&type=script&lang=js"
export * from "./usingLocales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__